import React, { useState } from "react";
import { Box, Typography, Tabs, Tab } from "@mui/material";
import { useLocation, useHistory } from "react-router-dom";

const UserManagementTabs = ({
  children,
  showHeader = true,
  title = "User Management",
  subtitle,
}) => {
  const location = useLocation();
  const history = useHistory();

  const [currentTab, setCurrentTab] = useState(() =>
    location.pathname.endsWith("/pending") ? 1 : 0
  );

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
    if (newValue === 1) {
      history.push("/management/admin/users/pending");
    } else {
      history.push("/management/admin/users");
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      {showHeader && (
        <Box sx={{ mb: 3 }}>
          <Typography
            variant="h3"
            sx={{ fontWeight: "bold", mb: subtitle ? 1 : 0 }}
          >
            {title}
          </Typography>

          {subtitle && (
            <Typography sx={{ fontSize: "1.2rem", color: "text.secondary" }}>
              {subtitle}
            </Typography>
          )}
        </Box>
      )}

      {/* Tab Navigation */}
      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          sx={{
            "& .MuiTab-root": {
              fontSize: "1.4rem",
              fontWeight: 500,
              textTransform: "none",
              minHeight: "48px",
            },
            "& .Mui-selected": {
              color: "#1976d2",
            },
            "& .MuiTabs-indicator": {
              backgroundColor: "#1976d2",
              height: "3px",
            },
          }}
        >
          <Tab label="All Users" />
          <Tab label="Pending Approvals" />
        </Tabs>
      </Box>

      {/* Content Area */}
      {children}
    </Box>
  );
};

export default UserManagementTabs;
